import { Table, Pagination } from "antd";
import { useEffect, useState } from "react";

const columns = [
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Email",
    dataIndex: "Email",
  },
  {
    title: "Status",
    dataIndex: "Status",
  },
  {
    title: "Edit",
    dataIndex: "Edit",
  },
];

const UserTable = ({
  list,
  handleApprovalChange,
  setCurrentUserToEdit,
  showeditModal,
}) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const mappedData = list.map((user, index) => ({
      key: index,
      Name: `${user.firstname} ${user.lastname}`,
      Status: (
        <label className="switch">
          <input
            onChange={() => handleApprovalChange(user.email)}
            type="checkbox"
            checked={user.status !== "pending"}
          />
          <span className="slider round"></span>
        </label>
      ),
      Email: user.email,
      Edit: (
        <img
          src="../../assets/icons/user-edit.svg"
          alt="edit"
          className="cursor-pointer user-icon"
          onClick={() => {
            showeditModal();
            setCurrentUserToEdit(user.email);
          }}
        />
      ),
    }));
    setData(mappedData);
  }, [list, handleApprovalChange, setCurrentUserToEdit, showeditModal]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const itemRender = (page, type, originalElement) => {
    if (type === "prev") {
      return <a>Prev</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = data.slice(startIndex, endIndex);

  return (
    <div className="client-listing-main ">
      <Table columns={columns} dataSource={currentData} pagination={false} />
      <Pagination
        className="mt-4"
        total={data.length}
        current={currentPage}
        pageSize={pageSize}
        onChange={handlePageChange}
        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        itemRender={itemRender}
      />
    </div>
  );
};

export default UserTable;
